// Who is reading, and where to send them when an action needs an account.
const root = document.querySelector<HTMLElement>('.learn');

export const session = {
  slug: root?.dataset.slug || '',
  signedIn: root?.dataset.signedIn === 'true',
  loginUrl: root?.dataset.loginUrl || '/Identity/Account/Login',
  // Reading is free; remembering needs an account. Sends the reader to the login page and back.
  requireSignIn(): boolean {
    if (session.signedIn) return true;
    window.location.href = session.loginUrl;
    return false;
  },
};
